import { lazy } from 'react';

const StudentSendTranscriptModal = lazy(
  () => import('./modals/StudentSendTranscript'),
);
const FullfillTranscriptModal = lazy(
  () => import('./modals/FullfillTranscript'),
);
const EditTranscriptDestination = lazy(
  () => import('./modals/EditTranscriptDestination'),
);
const TranscriptBatchUpload = lazy(
  () => import('./modals/TranscriptBatchUpload'),
);
const TranscriptUploadV2 = lazy(() => import('./modals/TranscriptUploadV2'));
const StudentTranscripts = lazy(() => import('./modals/StudentTranscripts'));
const TranscriptHistory = lazy(() => import('./modals/TranscriptHistory'));
const SendTranscriptMethod = lazy(
  () => import('./modals/SendTranscriptMethod'),
);
const PrintAllTranscripts = lazy(() => import('./modals/PrintAllTranscripts'));
const VerificationModal = lazy(() => import('./modals/VerificationModal'));
const AddAlumniModal = lazy(() => import('./modals/AddAlumniModal'));
const StudentVerificationModal = lazy(
  () => import('./modals/StudentVerificationModal'),
);
const TakeVerificationPhotoModal = lazy(
  () => import('./modals/TakeVerificationPhoto'),
);
const VerificationPhotoEdit = lazy(
  () => import('./modals/VerificationPhotoEdit'),
);
const StudentNote = lazy(() => import('./modals/StudentNote'));
const UploadImmunizationRecord = lazy(
  () => import('./modals/UploadImmunizationRecord'),
);
const ExternalRequestVerification = lazy(
  () => import('./modals/ExternalRequestVerification'),
);
const ExternalPhotoVerificationModal = lazy(
  () => import('./modals/ExternalPhotoVerificationModal'),
);
const RequestImmunizationRecord = lazy(
  () => import('./modals/RequestImmunizationRecord'),
);
const TranscriptRequestsGridModal = lazy(
  () => import('./modals/TranscriptRequestsGridDrawer'),
);
const DownloadImmunizationRecord = lazy(
  () => import('modules/RecordCenter/modals/DownloadImmunizationRecord'),
);
const VerifyAndDownloadImmunizationRecord = lazy(
  () =>
    import('modules/RecordCenter/modals/VerifyAndDownloadImmunizationRecord'),
);
const FormDetailsModal = lazy(() => import('./modals/FormDetailsModal'));

export default {
  'TRANSCRIPT_CENTER/STUDENT_SEND_TRANSCRIPT': StudentSendTranscriptModal,
  'TRANSCRIPT_CENTER/FULFILL_TRANSCRIPT': FullfillTranscriptModal,
  'TRANSCRIPT_CENTER/EDIT_TRANSCRIPT_DESTINATION': EditTranscriptDestination,
  'TRANSCRIPT_CENTER/ALUMNI_VERIFICATION': VerificationModal,
  TRANSCRIPT_UPLOAD: TranscriptBatchUpload,
  TRANSCRIPT_UPLOAD_MODAL: TranscriptUploadV2,
  STUDENT_TRANSCRIPTS: StudentTranscripts,
  TRANSCRIPT_HISTORY: TranscriptHistory,
  SEND_TRANSCRIPT_METHOD: SendTranscriptMethod,
  PRINT_ALL_TRANSCRIPTS: PrintAllTranscripts,
  ADD_ALUMNI_MODAL: AddAlumniModal,
  STUDENT_SIDE_VERIFICATION_MODAL: StudentVerificationModal,
  TAKE_WEBCAM_PHOTO_MODAL: TakeVerificationPhotoModal,
  VERIFICATION_PHOTO_EDIT_MODAL: VerificationPhotoEdit,
  STUDENT_NOTE_MODAL: StudentNote,
  UPLOAD_IMMUNIZATION_RECORD: UploadImmunizationRecord,
  EXTERNAL_REQUEST_VERIFICATION_MODAL: ExternalRequestVerification,
  EXTERNAL_PHOTO_VERIFICATION_MODAL: ExternalPhotoVerificationModal,
  REQUEST_IMMUNIZATION_RECORD_MODAL: RequestImmunizationRecord,
  TRANSCRIPT_REQUEST_GRID_MODAL: TranscriptRequestsGridModal,
  DOWNLOAD_IMMUNIZATION_RECORD: DownloadImmunizationRecord,
  VERIFY_DOWNLOAD_IMMUNIZATION_RECORD: VerifyAndDownloadImmunizationRecord,
  EXTERNAL_REQUEST_FORM_DETAILS_MODAL: FormDetailsModal,
};
